// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2OYfL","item":"PaymentsMobile_item__RHUMk","label":"PaymentsMobile_label__3XIzG","amount":"PaymentsMobile_amount__onq1e"};